import { SetParamsContentContextAction } from '@parcel2go/npm-p2g-app';

export class ConfigurableParameters implements SetParamsContentContextAction {
  constructor(params: { [key: string]: string | undefined }) {
    this.payload = {
      params: Object.fromEntries(
        Object.entries({ ...params }).filter((objEntry) => objEntry.some((entry) => entry !== undefined)) as [
          string,
          string
        ][]
      )
    };
  }
  type = 'SET_CONTENT_PARAMS' as const;
  payload: {
    params: {
      [key: string]: string;
    };
  };
}

export class CourierCountryConfigurableParameters extends ConfigurableParameters {
  constructor(params?: { courier?: string; service?: string; origin?: string; destination?: string }) {
    super({ ...params });
  }
}
